export enum WorkflowStepType {
  START = 'start',
  END = 'end',
  HUMAN_CONFIRM = 'human.confirm',
  HUMAN_FORM = 'human.form',
  HUMAN_REDIRECT = 'human.redirect',

  // | "sys.api_call" We do not have a usecase right now for this.
  SYS_API_CALL = 'sys.api_call',
  SYS_SUB_WORKFLOW = 'sys.sub_workflow',
  GATEWAY_PARALLEL_SPLIT = 'gateway.parallel_split',
  GATEWAY_PARALLEL_JOIN = 'gateway.parallel_join',
  GATEWAY_BOOLEAN_EXCLUSIVE_SPLIT = 'gateway.boolean_exclusive_split',
  GATEWAY_INCLUSIVE_SPLIT = 'gateway.inclusive_split',
  SYS_LLM = 'sys.llm',
  SYS_ROOTFI_SYNC = 'sys.rootfi_sync',
  SYS_EMAIL = 'sys.email',
  SYS_AI_AGENT = 'sys.ai_agent',
  SYS_WATCH_JOB = 'sys.watch_job',
  SYS_TOOL_CALL = 'sys.tool_call',
  // DEMO ONLY - Do not use in production
  DEMO_EMAIL = 'demo.email',
  DEMO_AI_FILLING_AGENT = 'demo.ai_filling_agent',
  HUMAN_REVIEW = 'human.review',
  HUMAN_ESIGN = 'human.esign',
}

export enum SysEmailRecipientMode {
  MANUAL = 'manual',
  MATTER_THREAD = 'matter_thread',
}

export enum EventHandlerEventType {
  STEP_ATTEMPT_STARTED = 'step.attempt.started',
  STEP_ATTEMPT_ENDED = 'step.attempt.ended',
}

export enum EventHandlerScheduleType {
  AFTER = 'after',
}

export enum EventHandlerActionType {
  NOTIFICATION_SEND = 'notification.send',
}

export enum NotificationChannel {
  EMAIL = 'email',
}

export enum EventHandlerExecutionStatus {
  SCHEDULED = 'Scheduled',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  FAILED = 'Failed',
}

export enum WorkflowRuntimeStatus {
  NOT_STARTED = 'NotStarted',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
}

export enum WorkflowRuntimeStepStatus {
  NOT_STARTED = 'NotStarted',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
  DISABLED = 'Disabled',
  FAILED = 'Failed',
}

export enum SubWorkflowStepMode {
  SINGLE = 'single',
  BATCH = 'batch',
}

export enum EsignStepMode {
  TEMPLATE = 'template',
  AD_HOC = 'ad_hoc',
}

export enum AgentFormResponseMode {
  NONE = 'none',
  ALL_PREVIOUS = 'all_previous',
  SELECTED = 'selected',
}

export enum AgentThreadSourceMode {
  NONE = 'none',
  ALL = 'all',
}

export enum WorkflowTriggerType {
  MANUAL = 'manual',
  INTERNAL_EVENT = 'internal.event',
}

export enum WorkflowStepTrackingCategory {
  INTAKE = 'INTAKE',
  PREPARATION = 'PREPARATION',
  DELIVERY = 'DELIVERY',
  CLOSEOUT = 'CLOSEOUT',
}

// Whether a SYS_AI_AGENT step's document work produced a stored file. Decided by the backend
// from the database, never from the model's text.
export enum WorkflowStepDocumentGenerationOutcome {
  GENERATED = 'GENERATED',
  NONE = 'NONE',
}

// DEMO ONLY - Do not use in production
export enum WorkflowDemoEmailType {
  VAT_NOTICE = 'vat_notice',
  SERVICE_COMPLETION = 'service_completion',
}

// DEMO ONLY - Do not use in production
export enum DemoAIFillingType {
  TM01_DIRECTOR_TERMINATION = 'tm01_director_termination',
  UBO_PSC_UPDATE = 'ubo_psc_update',
  VERIFY_SALES_TAX_CREDENTIALS = 'verify_sales_tax_credentials',
}
